import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAccessToken, getStoredUser } from '../../utils/tokenStorage';

const ProtectedRoute = ({ redirectTo = '/' }) => {
  const location = useLocation();
  const accessToken = getAccessToken();
  const user = getStoredUser();

  if (!accessToken || !user) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  // Force users flagged with mustChangePassword into the change password flow
  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;


